import React, { useEffect, useState, useContext } from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import { useTranslation } from 'react-i18next';
import { AppContext } from '../../../../App';

const useStyles = makeStyles(
  createStyles({
    tableHeader: {
      backgroundColor: 'grey',
      textAlign: 'center',
      color: 'white',
      padding: '1px',
      borderCollapse: `collapse`,
      minWidth: '80px',
      zIndex: 10,
    },
    tableFixHead: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      position: 'sticky',
      top: 0,
      left: 0,
    },
    tableFixC0: {
      borderWidth: '0px',
      outlineColor: '#dcdcdc',
      outlineWidth: '1px',
      outlineStyle: 'solid',
      width: '80px',
      position: 'sticky',
      zIndex: 20,
      top: 0,
      left: 0,
    },
    tableFixC1: {
      borderWidth: '0px',
      outlineColor: '#dcdcdc',
      outlineWidth: '1px',
      outlineStyle: 'solid',
      width: '80px',
      position: 'sticky',
      zIndex: 20,
      top: 0,
      left: 83,
    },
    tableFixC2: {
      borderWidth: '0px',
      outlineColor: '#dcdcdc',
      outlineWidth: '1px',
      outlineStyle: 'solid',
      width: '80px',
      position: 'sticky',
      zIndex: 20,
      top: 0,
      left: 166,
    },
    tableFixC3: {
      borderWidth: '0px',
      outlineColor: '#dcdcdc',
      outlineWidth: '1px',
      outlineStyle: 'solid',
      width: '80px',
      position: 'sticky',
      zIndex: 20,
      top: 0,
      left: 249,
    },
    tableTd: {
      borderWidth: '1px',
      borderColor: '#dcdcdc',
      borderStyle: 'solid',
      padding: '0px',
      minWidth: '80px',
    },
    colTime: {
      textAlign: 'center',
    },
  })
);

const DeviceRegistGridHeader: React.FC = () => {
  const { t } = useTranslation();
  const classes = useStyles();
  const { login } = useContext(AppContext);
  return (
    <TableRow>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixC0}>No</TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixC1}>
        {t('DeviceRegistGridHeader.実装', '実装')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixC2}>
        {t('DeviceRegistGridHeader.機器番号', '機器番号')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixC3}>
        {t('DeviceRegistGridHeader.機器名称', '機器名称')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.定格出力(kW)', '定格出力(kW)')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.Pole数', 'Pole数')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.電圧(V)', '電圧(V)')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.電源周波数(Hz)', '電源周波数(Hz)')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.定格電流値(A)', '定格電流値(A)')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.定格回転数(min-1)', '定格回転数(min-1)')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.励磁電流(A)', '励磁電流(A)')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.起動判定', '起動判定')}
        <br />
        {t('DeviceRegistGridHeader.電流閾値', '電流閾値')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.ベアリング呼び番号', 'ベアリング呼び番号')}
        <br />
        {t('DeviceRegistGridHeader.(負荷側)', '(負荷側)')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.ベアリング呼び番号', 'ベアリング呼び番号')}
        <br />
        {t('DeviceRegistGridHeader.(反負荷側)', '(反負荷側)')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.インバータ', 'インバータ駆動モータ')}
        <br />
        {t('DeviceRegistGridHeader.駆動モータ', '駆動モータ')}
      </TableCell>
      {login.IsIoT ? null : (
        <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
          {t('DeviceRegistGridHeader.EMC適用', 'EMC適用')}
        </TableCell>
      )}
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.インバータキャリア', 'インバータキャリア')}
        <br />
        {t('DeviceRegistGridHeader.周波数(Hz)', '周波数(Hz)')}
      </TableCell>
      {/* <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.補正乗数', '補正乗数')}
      </TableCell> */}
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.裕度(%)', '裕度(%)')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.キャリア', 'キャリア')}
        <br />
        {t('DeviceRegistGridHeader.周波数マスク', '周波数マスク')}
      </TableCell>
      {/* <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.零相電流', '零相電流')}
        <br />
        {t('DeviceRegistGridHeader.演算', '演算')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.正相電流', '正相電流')}
        <br />
        {t('DeviceRegistGridHeader.演算', '演算')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.逆相電流', '逆相電流')}
        <br />
        {t('DeviceRegistGridHeader.演算', '演算')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.正相電流', '正相電流')}
        <br />
        {t('DeviceRegistGridHeader.FFT', 'FFT')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.逆相電流', '逆相電流')}
        <br />
        {t('DeviceRegistGridHeader.FFT', 'FFT')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.振動変位', '振動変位')}
        <br />
        {t('DeviceRegistGridHeader.FFT', 'FFT')}
      </TableCell>
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.振動速度', '振動速度')}
        <br />
        {t('DeviceRegistGridHeader.FFT', 'FFT')}
      </TableCell> */}
      <TableCell className={classes.tableHeader + ' ' + classes.tableFixHead}>
        {t('DeviceRegistGridHeader.個別設定', '個別設定')}
      </TableCell>
    </TableRow>
  );
};

export default DeviceRegistGridHeader;
